/* globals VXConfig */
import React                           from 'react';
import PropTypes                       from 'prop-types';
import Translations                    from '../../../utils/Translations';
import Flux                            from '../../../flux/Flux';
import VIP30Grid                       from '../VIP30Grid';
import {getTranslation, onClickGetVip} from '../../VIPClub/VIPClubHelper';
import VXButtonOutline                 from '../../SimpleElements/VXButton/Presets/VXButtonOutline';
import {VXButtonLineConfig}            from '../../SimpleElements/VXButton/VXButtonConfig';
import withWindowWidth                 from '../../HigherOrderComponents/Utility/withWindowWidth';
import UrlBuilder                      from '../../../utils/UrlBuilder';
import ReloadHelper                    from '../../../utils/ReloadHelper';
import VXButton                        from '../../SimpleElements/VXButton/VXButton';
import {COLOR_TYPE_GOLD}               from '../../SimpleElements/VXButton/ButtonHelper';
import {capitalizeFirstLetter}         from '../../../utils/CommonUtils';
import {trackClick}                    from '../../../utils/GAHelper';

class VIP30Block extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isMobile: VXConfig.isVXMobilePlatform,
            isTablet: VXConfig.device.isTablet,
            isVIP:    Flux.Guest.isVip(),
        };

        this.onBtnClick = this.onBtnClick.bind(this);
    }

    onBtnClick(e) {
        ReloadHelper.reload(UrlBuilder.buildVIPClubUrl(), e);
    }

    render() {
        const {as: Tag}    = this.props;
        const smallVersion = this.props.windowWidth < 1080;
        const windowWidth  = Flux.Browser.getWindowSize().width;
        let classSuffix;
        switch (true) {
            case this.state.isMobile:
                classSuffix = ' -mobile';
                break;
            case this.state.isTablet && Flux.Browser.isLandscape():
                classSuffix = '';
                break;
            case this.state.isTablet:
                classSuffix = ' -tablet';
                break;
            default:
                classSuffix = '';
                break;
        }

        const t1 = (
                <h2 className={'vip30__header-headline' + classSuffix}>
                    {!Flux.Browser.isSexole() && <i className={'icon -icon-visitx-logo-single' + classSuffix}></i>}
                    <span className={'vip30__header-headline--gold' + classSuffix}>VIP</span>
                    <span className={'vip30__header-headline--normal' + classSuffix}>CLUB</span>
                    <span className={'vip30__header-headline--light' + classSuffix}>{getTranslation('videos')}</span>
                </h2>
        );
        const t2 = (
                <span className={'vipclub--benefits-grid-item-first-extra' + classSuffix}>
				<span className={'vipclub--benefits-grid-item-first-right--text' + classSuffix}>{Translations.get('VIP30.banner_right')}</span>
				<div className={'vipclub--benefits-grid-item-first-right--button' + classSuffix}>
					{!this.state.isVIP ?
                            <VXButton color={COLOR_TYPE_GOLD}
                                      line1={[new VXButtonLineConfig(getTranslation('vipNow'))]}
                                      onClick={onClickGetVip}
                                      icon={' -icon-single-arrow-right-line'}
                                      iconPosition={'right'}
                            />
                            : <VXButton color={COLOR_TYPE_GOLD}
                                        line1={[new VXButtonLineConfig(Translations.get('VIP30.your_benefits_button'))]}
                                        onClick={this.onBtnClick}
                                        icon={' -icon-single-arrow-right-line'}
                                        iconPosition={'right'}
                            />}
				</div>
			</span>
        );

        const headerDesktop = <div className="vipclub--vip30-block-header">
            <div className={'vipclub--benefits-grid-item-first'}>
                {(windowWidth >= 768 && windowWidth <= 1024 && Flux.Browser.isPortrait()) ?
                        <div className="vipclub--vip30-tablet-text-container">{t1}{t2}</div> :
                        <div className={'vipclub--benefits-grid-item-first--left'}>
                            {t1}
                            <div>
                                <span className={'vip30__videos-headline--gold'}>{getTranslation('exclusiveSelection')}</span>
                                <span className={'vip30__videos-headline--small'}> / {capitalizeFirstLetter(getTranslation('changingMonthly'))}</span>
                            </div>
                        </div>}
                <span className={'vipclub--benefits-grid-item-img-ass --overflow'} />
                {!smallVersion && t2}
                {smallVersion && <div className={'vipclub--benefits-grid-item-first-dummy'} />}
            </div>
        </div>;

        const headerMobile = <div className="vipclub--vip30-mobile-block-header">
            <div className="vipclub--vip30-mobile-image" />
            <div className="vipclub--vip30-mobile-text-container">
                {t1}
                {t2}
            </div>
        </div>;

        const header = this.props.isMobile ? headerMobile : headerDesktop;

        const count = this.props.isMobile ? 5 : 8;

        return (
                <Tag className="vipclub--vip30-block" id="vip30-block">
                    <div>
                        {header}
                    </div>
                    <VIP30Grid
                            filter={Flux.VideoV2.getDefaultFilterForCategory(Flux.Constants.Video.CategoriesV2.VIP_30_VIDEOS)}
                            order={Flux.VideoV2.getDefaultOrderForCategory(Flux.Constants.Video.CategoriesV2.VIP_30_VIDEOS)}
                            count={count}
                            isMobile={this.props.isMobile}
                            lazyImageLoading={this.props.lazyImageLoading}
                            headlineType={this.props.videoTitleType}
                    />
                    <div className="vipclub--video-block-btn-row">
                        <VXButtonOutline
                                line1={[new VXButtonLineConfig(!Flux.Guest.isLoggedIn() ? Translations.get('ActorGridLearnMoreText') : Translations.get('ShowAll'))]}
                                link={Flux.Guest.isVip() ? UrlBuilder.buildVIP30Url() : UrlBuilder.buildVIPClubUrl()}
                                callback={() => this.props.doGaTracking ? trackClick('vip', UrlBuilder.buildVIP30Url()) : null}
                        />
                    </div>
                </Tag>
        );
    }
}

VIP30Block.propTypes = {
    as:               PropTypes.string,
    windowWidth:      PropTypes.number.isRequired,
    isMobile:         PropTypes.bool,
    lazyImageLoading: PropTypes.bool,
    doGaTracking:     PropTypes.bool,
    videoTitleType:   PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
};

VIP30Block.defaultProps = {
    as:               'div',
    isMobile:         false,
    lazyImageLoading: false,
    doGaTracking:     false,
};

export default withWindowWidth(VIP30Block);

